import { DateSegment } from './date-segment'
import { useRef } from 'react'
import { AriaTimeFieldProps, TimeValue, useLocale, useTimeField } from 'react-aria'
import { useTimeFieldState } from 'react-stately'
import { cn } from '@/lib/utils'

/* 
This component supports a shadcn integration for a date-time-picker and was written by @uncvrd https://github.com/uncvrd/shadcn-ui-date-time-picker
Original issue: https://github.com/shadcn-ui/ui/issues/255
TODO: replace this component with an official shadcn datepicker after this issue is closed & supported by the library
*/

interface TimeFieldProps extends AriaTimeFieldProps<TimeValue> {
  variant?: 'default' | 'inverted'
}

function TimeField(props: TimeFieldProps) {
  const ref = useRef<HTMLDivElement | null>(null)

  const { locale } = useLocale()
  const state = useTimeFieldState({
    ...props,
    locale
  })
  const {
    fieldProps: { ...fieldProps }
  } = useTimeField(props, state, ref)

  const isInverted = props.variant === 'inverted'

  return (
    <div
      {...fieldProps}
      ref={ref}
      className={cn(
        'ring-offset-background focus-within:ring-ring focus-visible:ring-ring rounded-xs inline-flex h-10 w-full flex-1 border px-3 py-2 text-sm focus-within:ring-2 focus-within:ring-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        isInverted
          ? 'border-outline-inverted bg-surface-inverted text-on-surface-inverted'
          : 'border-outline-variant bg-surface-high',
        props.isDisabled ? 'cursor-not-allowed opacity-50' : ''
      )}
    >
      {state.segments.map((segment, i) => (
        <DateSegment key={i} segment={segment} state={state} />
      ))}
    </div>
  )
}

export { TimeField }
